/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

export var EVENT_END_DELAY = 100;
export var DEFAULT_THROTTLE_RATE = 50;
